export interface AdminMenuItem {
  title: string;
  href?: string;
  isSeparator?: boolean;
}

export const adminMenuItems: AdminMenuItem[] = [
  { title: 'Main', href: '/admin' },
  { title: 'Audit', href: '/admin/audits' },
  { title: 'Autojoin Domains', href: '/admin/autojoin_domains' },
  { title: 'Background Jobs', href: '/admin/jobs' },
  { title: 'Broadcasts', href: '/admin/broadcast_notifications' },
  { title: 'Billing', href: '/admin/billing' },
  { title: 'Charts', href: '/admin/charts' },
  { title: 'Usage', href: '/admin/charts/usage' },
  { title: 'Client Releases', href: '/admin/client_releases' },
  { title: 'Common Domains', href: '/admin/common_domains' },
  { title: 'Custom Domains', href: '/admin/certificates' },
  { title: 'Collections', href: '/admin/collections' },
  { title: 'Organizations', href: '/admin/organizations' },
  { title: 'True-ups', href: '/admin/trueup' },
  { isSeparator: true },
  { title: 'Experiments', href: '/admin/experiments' },
  { title: 'Flipper', href: '/admin/flipper' },
  { isSeparator: true },
  { title: 'PgHero', href: '/admin/pghero' },
  { title: 'Sidekiq', href: '/admin/sidekiq' },
  { title: 'Coverband', href: '/admin/coverage' },
];
